module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./TenantDetailView.js"));
	}, "tenantDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=tenantDetailView!./src/pages/TenantMgmt/TenantDetail/TenantDetailView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=tenantDetailView!./src/pages/TenantMgmt/TenantDetail/TenantDetailView.js
// module chunks = 43